import React, { Component } from 'react';
import 'antd/dist/antd.css';
import { Layout, Menu, Icon, Drawer, Dropdown, Popconfirm } from 'antd';
import './MenuSider.css';
import { Link, NavLink } from 'react-router-dom';
import { connect } from 'react-redux'
import languageData from '../Constants/Data'
import AppLocale from '../lngProvider';
import IntlMessages from '../util/IntlMessages';
import icon_en_US from '../app/routes/images/icon.en-America.png';
import icon_th_TH from '../app/routes/images/icon.th-TH.png';
import menu_icon from '../app/routes/images/menu.icon.png';
import { Constants } from '../Constants/Constants'
const { SubMenu } = Menu;
const { Header, Content } = Layout;

class MenuSider extends Component {
  constructor() {
    super();

    this.state = {
      visible: false,
      name: "User Profile"
    };
  }


  showDrawer = () => {
    this.setState({
      visible: true,
    });
  };

  onClose = () => {
    this.setState({
      visible: false,
    });
  };

  signout = () => {
    const username = window.localStorage.getItem('Username')
    const password = window.localStorage.getItem('Password')
    window.localStorage.clear()
    window.localStorage.setItem('Username', username)
    window.localStorage.setItem('Password', password)
    // window.localStorage.setItem('authen', null)
    this.props.ClearState1();
    this.props.Sign_Out_Authen();

    window.location.href = "auth/logout";

    //this.props.history.push('/')

  }
  onchangeEN = () => {
    this.props.SWITCH_LANGUAGE(languageData[0]);
  }
  onchangeTH = () => {
    this.props.SWITCH_LANGUAGE(languageData[1]);
  }

  // onchangeOK = () => {
  //   this.props.SWITCH_LANGUAGE(languageData[0]);
  // }
  // onchangeCancel = () => {
  //   const { locale } = this.props.setting
  //   const currentAppLocale = AppLocale[locale.locale];
  //   if (currentAppLocale.locale === 'th-TH') {
  //     this.props.SWITCH_LANGUAGE(languageData[0]);
  //   } else {
  //     this.props.SWITCH_LANGUAGE(languageData[1]);
  //   }
  // }

  render() {

    const { locale } = this.props.setting
    const currentAppLocale = AppLocale[locale.locale];
    var title_change_lang = (
      <IntlMessages id="menu.change_language" />
    )
    var icon_language
    var current_language_ok
    var current_language_cancel
    // console.log(currentAppLocale.locale)
    //dropdown select language

    const menu = (
      <Menu>
        <Menu.Item key="0" onClick={this.onchangeTH}>
          <img alt="TH" src={icon_th_TH} style={{ width: "25px", height: "25px", marginRight: "10px" }} />
          <IntlMessages id="icon.thailand" />
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item key="1" onClick={this.onchangeEN}>
          <img alt="EN" src={icon_en_US} style={{ width: "25px", height: "25px", marginRight: "10px" }} />
          <IntlMessages id="icon.england" />
        </Menu.Item>
      </Menu>
    );

    if (currentAppLocale.locale === 'en-US') {
      icon_language = icon_en_US
      current_language_ok = "EN"
      current_language_cancel = "TH"
    } else {
      icon_language = icon_th_TH
      current_language_ok = "TH"
      current_language_cancel = "EN"
    }
    const title = (
      <Link to="/"><span style={{ color: "black" }}>Safety Observation</span></Link>
    )
    var RoleID = window.localStorage.getItem("RoleID")
    // console.log(typeof (RoleID))
    return (
      <div>
        <Drawer
          title={title}
          // title="Safety Observation"
          placement="left"
          closable={false}
          onClose={this.onClose}
          visible={this.state.visible}
          className="Tap-menu" >
          <Menu mode="inline" >

            <SubMenu key="sub1" title={<span><Icon type="dashboard" /><IntlMessages id="menu.dashboard" /></span>} subMenuCloseDelay="2">
              <Menu.Item key="1" ><Link to="/dashboard_myself"><IntlMessages id="menu.dashboard_myself" /></Link></Menu.Item>
              <Menu.Item key="3" ><Link to="/DepartmentDashboard"><IntlMessages id="menu.dashboardOrganization" /></Link></Menu.Item>
              <Menu.Item key="19" ><Link to="/SOParticipation"><IntlMessages id="menu.so_target" /></Link></Menu.Item>
              <Menu.Item key="4" ><Link to="/CompanyDashboard"><IntlMessages id="menu.dashboardCompany" /></Link></Menu.Item>
              <Menu.Item key="2"><Link to="/dashboard_SCG"><IntlMessages id="menu.dashboard_all" /></Link></Menu.Item>
              <Menu.Item key="observetype"><Link to="/dashboard/observetype"><IntlMessages id='menu.Observation_type_report' /></Link></Menu.Item>
              <Menu.Item key="Y2DObseveType"><Link to="/dashboard/Y2DObseveType"><IntlMessages id='menu.Y2D_Observ_report' /></Link></Menu.Item>
              <Menu.Item key="Y2DJobType"><Link to="/dashboard/Y2DJobType"><IntlMessages id='menu.Y2D_JobType_report' /></Link></Menu.Item>

            </SubMenu>
            <SubMenu key="sub2" title={<span><Icon type="form" /><IntlMessages id="menu.observationchecklist" /></span>}>
              {/*<Menu.Item key="5"><Link to="/newobservation_basic_info"><IntlMessages id="menu.observationchecklist_new_observation_checklist" /></Link></Menu.Item>*/}
              <Menu.Item key="5"><Link to="/observation/request"><IntlMessages id="menu.observationchecklist_new_observation_checklist" /></Link></Menu.Item>
              <Menu.Item key="6"><Link to="/myobservation"><IntlMessages id="menu.observationchecklist_my_observation_checklist" /></Link></Menu.Item>
            </SubMenu>
            <SubMenu key="sub_capa" title={<span><Icon type="form" /><IntlMessages id="menu.capa" /></span>}>
              <Menu.Item key="19"><Link to="/capa_assignee"><Icon type="carry-out" /><IntlMessages id="menu.capa_action" /></Link></Menu.Item>
              <Menu.Item key="20"><Link to="/capa_manager"><Icon type="carry-out" /><IntlMessages id="menu.capa_management" /></Link></Menu.Item>
              <Menu.Item key="capa_manager_csm"><Link to="/capa_manager_csm"><Icon type="carry-out" /><IntlMessages id="menu.capa_management_csm" /></Link></Menu.Item>
            </SubMenu>

            {
              // RoleID eq 5 it mean user is Admin
              (RoleID === "5" || RoleID === '3' || RoleID === '6') && (
                <SubMenu key="sub3" title={<span><Icon type="setting" /><IntlMessages id="menu.system_management" /></span>}>
                  <SubMenu key="Sub4" title={<span><IntlMessages id="menu.system_management_master_data" /></span>}>
                    <Menu.Item key="7"><Link to="/usermd"><IntlMessages id="menu.system_management_master_data_user" /></Link></Menu.Item>
                  </SubMenu>
                  <Menu.Item key="setting_sot_editdata"><Link to="/setting_sot_editdata">SOT Edit Data</Link></Menu.Item>
                  <Menu.Item key="setting_sot_editdata_csm"><Link to="/setting_sot_editdata_csm">SOT Edit Data (CSM)</Link></Menu.Item>
                </SubMenu>
              )
            }
            <SubMenu key="sub4" title={<span><Icon type="solution" /><IntlMessages id="menu.feedback" /></span>}>
              <Menu.Item key="8"><Link to="/feedback_myself"><IntlMessages id="menu.feedback_myself" /></Link></Menu.Item>
              {
                (RoleID === "5" || RoleID === '3' || RoleID === '6') ? 
                (<Menu.Item key="9"><Link to="/feedback_all"><IntlMessages id="menu.feedback_all" /></Link></Menu.Item>) : null
              }
              {
                (RoleID === "5" || RoleID === '3' || RoleID === '6') ? 
                (<Menu.Item key="menu_feedback_all_csm"><Link to="/feedback_all_csm"><IntlMessages id="menu.feedback_all_csm" /></Link></Menu.Item>) : null
              }
            </SubMenu>
            <SubMenu key="sub5" title={<span><Icon type="global" /><IntlMessages id="menu.change_language" /></span>}>
              <Menu.Item key="10" onClick={this.onchangeTH}>
                <img alt="TH" src={icon_th_TH} style={{ width: "25px", height: "25px", marginRight: "10px" }} /> th-TH
              </Menu.Item>
              <Menu.Item key="11" onClick={this.onchangeEN}>
                <img alt="EN" src={icon_en_US} style={{ width: "25px", height: "25px", marginRight: "10px" }} /> en-US
              </Menu.Item>
            </SubMenu>
            {
              (RoleID === "5") && (
                <SubMenu key="sub6" title={<span><Icon type="database" /><IntlMessages id="menu.master" /></span>}>
                  <Menu.Item key="17"><Link to="/master_jobtype"><IntlMessages id="menu.master_jobtype" /></Link></Menu.Item>
                  <Menu.Item key="18"><Link to="/master_rootcause"><IntlMessages id="menu.master_rootcause" /></Link></Menu.Item>
                </SubMenu>
              )
            }
            <Menu.Item key="12"><Link to="/"><Icon type="user" /><IntlMessages id="menu.profile" /></Link></Menu.Item>
            <SubMenu key="sub7" title={<span><Icon type="play-circle" /><IntlMessages id="menu.manual" /></span>}>
              <Menu.Item key="16" ><Link to="/manual"><IntlMessages id="menu.vdomanual" /></Link></Menu.Item>
              <Menu.Item key="21" ><a target="_blank" href="https://scgchemicals.scg.com/sd/Documents/2019%20Safety%20Operation/3.%20Safety%20Promotion/SOT/SOT%20FAQ%20and%20Company%20Admin.%20for%20Communication_rev.01.pdf"><IntlMessages id="menu.faq" /></a></Menu.Item>
            </SubMenu>
            <Menu.Item key="14" >
              <Link to="/SOHandbook">
                <Icon type="book" /><IntlMessages id="menu.soHandbook" />
              </Link>
            </Menu.Item>
            <Menu.Item key="20" >
              <Link to="/companyadmin">
                <Icon type="smile" /><IntlMessages id="menu.companyadmin" />
              </Link>
            </Menu.Item>
            <Menu.Item key="13" >
              <Link to="/about_us">
                <Icon type="info-circle" /><IntlMessages id="menu.about_us" />
              </Link>
            </Menu.Item>
            <Menu.Item key="15" onClick={this.signout} style={{ borderTop: "1px solid #CCCCCC", borderBottom: " 1px solid #CCCCCC" }}>
                <Link to="/"><Icon type="logout" style={{ color: "red" }} /><IntlMessages id="menu.sign_out" /></Link>
            </Menu.Item>
          </Menu>
          <div style={{ fontSize: '10px', marginTop: '10px', bottom: '20px', textAlign: 'center' }}>
            <b>Powered By</b><br />
            <b>e-Business, <br />Chemicals Business</b><br />
            <b>{Constants.APP_VERSION}</b>
          </div>
        </Drawer>
        <Layout >
          <Header style={{ backgroundColor: "rgb(0,152,139)", padding: 0, overflow: "hidden" }}>

            <div className="topic" style={{ fontSize: "18px", width: "100%" }}>
              <div style={{ float: "left", width: "10%", cursor: "pointer" }}>
                <img alt="menu-icon" src={menu_icon} style={{ width: "19px", height: "19px", marginLeft: "50%" }} onClick={this.showDrawer} type={this.state.collapsed ? "menu-unfold" : "menu-fold"} />
              </div>

              {/* <div className="manu_titile">{this.props.title}</div> */}
              <span style={{ fontSize: "18px", marginLeft: "20px", color: "white", textAlign: "center" }}>{this.props.title}</span>
              {/* <span style={{ float: "right", marginRight: "20px", cursor: "pointer" }}>
                <Dropdown overlay={menu} trigger={['click']} >
                  <img alt={currentAppLocale.locale} src={icon_language} style={{ width: "25px", height: "25px" }} />
                </Dropdown>
              </span> */}
              {/* <img onClick={this.onchangeTH} alt="TH" src="icon/icon.thailand.png" style={{ width: "25px", height: "25px"}} /> */}
            </div>
          </Header>
          <Content
            style={{
              // margin:"12px 0",
              // background: "#CCCCCC",
              backgroundColor: "#FFF",
            }}
          >
            <div>
              {this.props.children}

            </div>
          </Content>
        </Layout>
      </div>
    );
  }
}

const mapStatetoProps = (state) => {
  return {
    detail: state.detail,
    authen: state.authen,
    setting: state.setting,
  }
}

const mapDispatchProps = (dispatch) => {
  return {
    ClearState1: () => {
      dispatch({
        type: "ClearState1",
      })
    },
    Sign_Out_Authen: () => {
      dispatch({
        type: "Sign_Out_Authen",
      })
    },
    SWITCH_LANGUAGE: (value) => {
      dispatch({
        type: "SWITCH_LANGUAGE",
        locale: value
      })
    },
  }
}

export default connect(mapStatetoProps, mapDispatchProps)(MenuSider)
